import { memo } from 'react';
import LiveInferenceImage from '../../../assets/images/liveInference.svg';
import StreamLoader from '../../../assets/images/loader.svg';

interface StreamViewProps {
  image: string;
  loading: boolean;
  selectedCamera: string;
  started: boolean;
}

const StreamView = memo(
  ({ image, loading, selectedCamera = '', started }: StreamViewProps) => {
    if (!selectedCamera) {
      return (
        <img
          src={LiveInferenceImage}
          style={{ width: '60%', marginTop: '40px', marginBottom: '40px' }}
          alt="live-inference-placeholder"
        />
      );
    }

    if (loading) {
      return (
        <div
          style={{
            height: '600px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <img src={StreamLoader} style={{ width: '220px' }} alt="loading" />
          <p style={{ fontSize: '18px' }}>
            🔄 Starting camera... Please wait up to 30 seconds while we connect
            you! ⏳
          </p>
        </div>
      );
    }

    // Return null if no image
    if (!image) {
      return null;
    }

    return (
      <div style={{ position: 'relative', width: '60vw' }}>
        <img
          src={image}
          alt="live-inference"
          draggable={false}
          style={{ height: '65vh', width: '100%' }}
        />
        {started && (
          <div style={{ position: 'absolute', top: 2, left: 8 }}>
            <svg height="10" width="10" className="blinking">
              <circle cx="5" cy="5" r="5" fill="red" />
            </svg>
            <span className="text-red-500"> Live</span>
          </div>
        )}
      </div>
    );
  }
);

StreamView.displayName = 'StreamView'; // Add display name for debugging

export default StreamView;
